import { baseSort, groupItemsByAttr } from "./general.utils";

export const dispatchSearchFunds = (data) => {
  const result = data ? data.fundInformation : {};
  return result;
};

export const dispatchSearchPortfolios = (state, data) => {
  let result = [];
  let keyword = state.searchText.toUpperCase();

  if (data) {
    Object.keys(data).map((index) => {
      let currentCode = data[index].fundCode.toUpperCase();
      if (currentCode.includes(keyword) || !keyword) {
        result.push({
          'thailandFundCode': data[index].fundCode,
          'categoryName': data[index].category
        })
      }
    })
  };
  return result;
};

export const secondsOfDay = (time) => {
  if (time) {
    let str = time.split(':');
    let initTime = 3600;
    let seconds = 0;
    str.forEach((x) => {
      seconds += x*initTime;
      if (initTime > 0) {
        initTime /= 60;
      }
    })
    return parseInt(seconds);
  }
  return null;
};

// Prevent press enter and removed focus on current target.
export const handlePreventDefault = (e) => {
  if (e.key === 'Enter') {
    e.preventDefault();
    e.target.blur();
  }
}

export const getFundList = (items, keyword) => {
  const filterFunds = filterFundBy(items, keyword);
  const groupFilterFunds = groupItemsByAttr(filterFunds, 'accountType');

  // Sort Groups
  const sortGroupFilterFunds = Object.keys(groupFilterFunds).sort().reduce(function (result, key) {
    result[key] = groupFilterFunds[key];
    return result;
  }, {});

  return sortGroupFilterFunds;
}

export const filterFundBy = (items, target, filterNames) => {
  if (!items || !items.length) return [];

  const targetValue = target?.toUpperCase();
  const filterBy = filterNames
    ? filterNames.length
      ? filterNames
      : [filterNames]
    : ['fundCode', 'categoryNameTh'];

  const filterItems = targetValue
    ? items.filter(item => filterBy.find(
        key => item[key]?.toUpperCase().includes(targetValue)
      ))
    : items;

  const sortFilterItems = filterItems.sort((a, b) => baseSort(a.fundCode, b.fundCode, 'a'));

  return sortFilterItems;
}

export const findNode = (tree, key, value, childrenKey) => {
  for (let node of tree) {
    if (node[key] === value) return node

    if (node[childrenKey]) {
      let desiredNode = findNode(node[childrenKey], key, value, childrenKey)
      if (desiredNode) return desiredNode
    }
  }
  return false
}

export const flatNode = ({ subItems = [], ...rest }) =>  [rest, ...subItems?.flatMap(flatNode) || []]